import {Component, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import Swiper from "swiper";

@Component({
    selector: 'app-image-viewer',
    templateUrl: './image-viewer.component.html',
    styleUrls: ['./image-viewer.component.scss'],
    standalone: false
})
export class ImageViewerComponent implements OnInit {
  img;

  swiper = new Swiper('.swiper', {
    zoom: {
      maxRatio: 3,
      toggle: true
    },
    on: {
      init: function (){
        console.log('Initialized')
      }
    }
  });
  constructor(
    private modalController: ModalController
  ) {
  }


  async ngOnInit() {

  }

  public async closeModal(): Promise<void> {
    await this.modalController.dismiss(null, 'cancel');
  }
}
